import StrategyBalanceSheet from './StrategyBalanceSheet';

const BalanceSheet = ({
  editable,
  cashflowEditable,
  assetLiabilityEditable,
  calculatedStrategy,
  onDuplicateAssetLiabilityClick,
  onAssetLiabilityEditClick,
  onAssetLiabilityDeleteClick,
  onAddEventClick,
  onEditCashflowClick,
  onDeleteCashflowClick,
  onAddCashflowClick,
  disabled,
  onNameUpdateSubmit,
  quickRenaming,
  showCashflowTable,
  setBalanceSheetCashflowCsvMeta
}) => {
  return (
    <div className="d-flex flex-column gap-4">
      <StrategyBalanceSheet
        editable={editable}
        cashflowEditable={editable && cashflowEditable}
        assetLiabilityEditable={editable && assetLiabilityEditable}
        disabled={disabled}
        onDuplicateAssetLiabilityClick={onDuplicateAssetLiabilityClick}
        strategy={calculatedStrategy}
        onEditClick={onAssetLiabilityEditClick}
        onDeleteClick={onAssetLiabilityDeleteClick}
        onAddEventClick={onAddEventClick}
        onEditCashflowClick={onEditCashflowClick}
        onDeleteCashflowClick={onDeleteCashflowClick}
        onAddCashflowClick={onAddCashflowClick}
        onNameUpdateSubmit={onNameUpdateSubmit}
        quickRenaming={quickRenaming}
        showCashflowTable={showCashflowTable}
        setBalanceSheetCashflowCsvMeta={setBalanceSheetCashflowCsvMeta}
      />
    </div>
  );
};

export default BalanceSheet;
